import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "nsc.cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after a short delay if consent not yet given
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-4 left-4 right-4 md:right-auto md:max-w-lg z-40 bg-[#0B2343] text-white shadow-2xl border border-white/10"
          data-testid="cookie-banner"
        >
          <div className="p-5">
            <div className="flex items-start gap-3">
              <Cookie className="text-[#C89B3C] flex-shrink-0 mt-0.5" size={22} />
              <div className="flex-1">
                <h3 className="font-serif font-bold mb-1">Cookies on Noble Strategies</h3>
                <p className="text-sm text-slate-300 leading-relaxed">
                  We use essential cookies to keep you signed in to the client portal. We don't use
                  advertising or cross-site tracking cookies.{" "}
                  <Link to="/cookies" className="text-[#C89B3C] underline hover:text-white">
                    Read our cookie notice
                  </Link>
                  .
                </p>
                <div className="flex gap-2 mt-4">
                  <button
                    onClick={accept}
                    className="bg-[#C89B3C] text-slate-900 px-5 py-2 text-sm font-medium hover:bg-[#e0b356] transition-colors"
                    data-testid="cookie-accept"
                  >
                    Got it
                  </button>
                </div>
              </div>
              <button
                onClick={accept}
                className="text-slate-400 hover:text-white flex-shrink-0"
                aria-label="Dismiss"
                data-testid="cookie-dismiss"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
